import { t } from '@lingui/macro';
import React from 'react';
import { connect } from 'react-redux';
import { withDisplayedLayersCheck } from '../../../HOC/withDisplayedLayersCheck';
import { onChangeMapFilters } from '../../../ac/onChangeMapFilters';
import * as V from '../../../constants/variables';
import { getUserTapsColorScope } from '../../../utils/getUserTapsColorScope';
import { ColoredItemsLegend } from '../../LegendRenderer/types/ColoredItemsLegend';
import { MultiGroupFilter } from '../MultiGroupFilter';
import { LEGEND_ICON_TYPES } from '../../../types/legendTypes';
import styles from '../FilterSidebar.module.css';

const getLabel = (isTaps, value, mode) => `≥ ${value} ${mode === V.SHARE ? ' %' : isTaps ? t`тапов` : t`открытий`}`;
const TapsOpensFilterComponent = ({ tapsDays, onChangeMapFilters, layer, opensDays, tapsMode, opensMode }) => {
    const isTaps = layer.id === V.taps;
    const prefix = isTaps ? 'taps' : 'opens';
    const filterValue = isTaps ? tapsDays : opensDays;
    const activeMode = isTaps ? tapsMode : opensMode;
    const colorArray = activeMode === 'ABS' ? V.userTapsHexagonColor : V.userTapsHexagonColorSh;
    const mode = activeMode === 'ABS' ? 'ABS' : 'SHARE';
    const onChange = ({ target: { value } }) => {
        const key = isTaps ? 'tapsDays' : 'opensDays';
        onChangeMapFilters(key, +value);
    };
    const onChangeMode = mode => {
        const key = isTaps ? 'tapsMode' : 'opensMode';
        onChangeMapFilters(key, mode);
    };
    const hexLegendItems = getUserTapsColorScope(filterValue, activeMode, prefix)
        .map((value, index) => ({
            id: value,
            label: { id: `label_${value}`, message: getLabel(isTaps, value, activeMode) },
            fill: colorArray[index],
        }))
        .filter((_, index) => index !== 0 || activeMode !== 'ABS');
    const hexLegendContent = (
        <ColoredItemsLegend
            items={hexLegendItems}
            icon={LEGEND_ICON_TYPES.HEXAGON}
            renderConfig={{
                showIcon: true,
                iconSize: '30px',
                iconOpacity: 0.8,
                fontSize: '0.85rem',
            }}
        />
    );
    return (
        <div>
            <div className={styles.legHead}>
                {t`Агрегированные`}
                {' '}
                {isTaps ? t`тапы:` : t`открытия:`}
            </div>

            <MultiGroupFilter
                isVisible={true}
                groups={[
                    {
                        id: 'mode',
                        type: 'button-group',
                        value: activeMode,
                        onChange: e => onChangeMode(e.target.value),
                        options: V.TapsOpensModeOptions.map(({ type, label }) => ({
                            value: type,
                            label,
                        })),
                    },
                    {
                        id: 'days',
                        value: String(filterValue),
                        onChange,
                        options: V.userTapsFilterValues.map(value => ({
                            value,
                            label: t`${value} дней`,
                        })),
                    },
                ]}
                footer={(
                    <div>
                        {hexLegendContent}
                        <div style={{ padding: '10px' }}>
                            <small>
                                {mode === 'ABS' ? t`` : t`Разница в % от среднего значения по региону`}
                            </small>
                        </div>
                    </div>
                )}
            />
        </div>
    );
};
const mapStateToProps = ({ mapFilters: { tapsDays, opensDays, tapsMode, opensMode } }) => ({
    tapsDays, opensDays, tapsMode, opensMode,
});
const ConnectedComponent = connect(mapStateToProps, { onChangeMapFilters })(TapsOpensFilterComponent);

export const TapsFilter = withDisplayedLayersCheck(ConnectedComponent, V.taps);
export const OpensFilter = withDisplayedLayersCheck(ConnectedComponent, V.opens);

